<template>
  <div class="login_container">
    <el-link class="link2" icon="el-icon-back" href="#/signup">Return to the home page</el-link>
    <div class="login_box">
      <!--  头像区域-->
      <div class="left-box">
        <div class="img" style="position: absolute;left: -23%;top: 25.25%;">
          <h2 style="position: absolute;top: -100px;left: 190px;color: black">Conference platform of<br> China Non-Ferrous Metal</h2>
          <img src="../assets/2.svg" height="302" width="750" />
        </div>
      </div>
      <div class="avatar_box">
        <img src="../assets/logo1.jpg" alt="">
      </div>
      <!-- 登陆表单区域 -->
      <div class="menu">
        <el-form ref="loginFormRef" :model="loginForm" label-width="0px" :rules="loginFormRules" class="login_form">
          <!--            <h2>登录</h2>-->
          <!--    用户名-->
          <div class="menu">
            <el-form-item prop="username" style="margin-top: 100px">
              <el-input v-model.trim="loginForm.username" @keyup.enter.native="login"  prefix-icon="el-icon-user" placeholder="Please enter your email"></el-input>
            </el-form-item>
            <!--    密码-->
            <el-form-item prop="password">
              <el-input v-model.trim="loginForm.password" @keyup.enter.native="login"  prefix-icon="el-icon-lock" placeholder="Please enter the login password
" type="password"></el-input>
            </el-form-item>
            <!--    按钮区域-->
            <el-form-item class="btns">
              <el-button class="button1" type="primary" @click="login">login</el-button>
              <el-button class="button2" type="info" @click="register">register</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <!--        忘记密码区域-->
      <div class="forget"><a @click="forget">Forgot password?</a></div>
    </div>
    <span style="position: absolute;color: white;font-size: 14px;left: 50%;top: 95%;transform: translate(-50%,-50%);">Chinese Society of Nonferrous Metals  All rights reserved  京ICP备15049308号-2</span>
    <span style="position: absolute;color: white;font-size: 14px;left: 50%;top: 98%;transform: translate(-50%,-50%);">Address: B 12 Fuxing Road, Haidian District, Beijing     Zip code: 100814    Email:nfsoc@163.com</span>
  </div>
</template>

<script>
export default {
  data () {
    return {
      // 登录表单的数据对象
      loginForm: {
        username: '',
        password: '',
        confId:"",
      },
      // 表单的验证规则
      loginFormRules: {
        // 验证用户名
        username: [
          { required: true, message: 'Please enter your email', trigger: 'blur' },
          { min: 3, max: 25, message: 'The length ranges from 3 to 15 characters', trigger: 'blur' }
        ],
        // 验证密码
        password: [
          { required: true, message: 'Please enter the login password', trigger: 'blur' },
          { min: 6, max: 25, message: 'The length ranges from 3 to 15 characters', trigger: 'blur' }
        ]
      },

      route:'',
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // console.log(to)
      console.log(from)
      if(from.fullPath === '/register' || from.fullPath === '/forget'|| from.fullPath === null){
        vm.route = '/signup'
      }else{
        vm.route = from.fullPath
      }
    });
  },

  methods: {
    // 点击按钮
    register () {
      // console.log(this);
      let id = window.localStorage.getItem("id")
      window.sessionStorage.setItem("id",id)
      this.$router.push('/register?id='+id)
    },
    login() {
      let id =this.$store.state.confId
      this.loginForm.confId = id
      this.$refs.loginFormRef.validate(async valid => {
        if (!valid) return false
        const { data: res } = await this.$http.post('api/login', this.loginForm)
        // console.log(res)
        if(res.code === 200) {
          window.sessionStorage.setItem(`token${id}`, res.token)
          window.localStorage.setItem(`token${id}`, res.token)
          this.$message.success('Login successful')
          // this.$router.back();
          this.$router.push("/signUp/signUpInformation?id="+id+"&modularId"+id)
          // this.$router.push(this.route)
        } else if (res.code === 500) return this.$message.error('The user does not exist or the password is incorrect')
      })
    },
    forget(){
      let id = window.localStorage.getItem("id")
      window.sessionStorage.setItem("id",id)
      this.$router.push('/forget?id='+id)
    },
    close(){
      window.open("about:blank", "_top").close()
    }
  }
}
</script>

<style lang="less" scoped>
.login_container{
  background-color: #35597b;
  //opacity: 0.9;
  width: 100%;
  height: 100%;
}
.el-menu-demo{
  border: 1px solid rgba(255,255,255,.3);
}
.left-box{
  overflow: hidden;
  width: 520px;
  height: 450px;
  border-radius: 3px;
  //background-color: rgba(222, 218, 218, 0.2);
  background-color: white;
  border: 1px solid rgba(255,255,255,0.2);
  //border-right: none;
  box-shadow: 0 3px 0 rgba(12, 12, 12, 0.03);
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  position: absolute;
  left: -260px;
  top: 50%;
  transform: translate(-50%,-50%);
}
.login_box{
  width: 400px;
  height: 450px;
  background-color: rgba(222, 218, 218, 0.2);
  border-radius: 3px;
  border: 1px solid rgba(201, 197, 197, 0.3);
  -moz-box-shadow: 0 3px 0 rgba(12, 12, 12, 0.03);
  -webkit-box-shadow: 0 3px 0 rgba(12, 12, 12, 0.03);
  box-shadow: 0 3px 0 rgba(12, 12, 12, 0.03);
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  position: absolute;
  left: 65%;
  top: 50%;
  transform: translate(-50%,-50%);

  h2{
    color: white;
    position: absolute;
    top: -15%;
    left: 42%;
  }


  .avatar_box{
    height: 130px;
    width: 130px;
    border: solid 1px #eee;
    border-radius: 50%;
    padding: 10px;
    box-shadow: 0 0 10px #ddd;
    position: absolute;
    right: 13%;
    transform: translate(-50%,-50%);
    background-color: #fff;
    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      background-color: #eee;
    }
  }
}
.btns{
  width: 100%;
  padding: 20px 55px;
  .button1{
    height: 37px;
    margin-right: 15px;
  }
  .button2{
    height: 37px;
  }
}
.login_form{
  width: 100%;
  //height: 150px;
  position: absolute;
  padding: 0 60px;
  top: 65px;
  box-sizing: border-box;
  //background-color: red;
}
.forget{
  width: 100%;
  position: absolute;
  bottom: 0;
  height: 35px;
  color:#ccc ;
  font-size: 14px;
  line-height: 35px;
  box-sizing: border-box;
  padding: 0 40px;
  text-align: center;
  cursor: pointer;
  border-top: 1px solid #ccc;
  transition: all .3s;
  a{
    color: #f6f5f5;
    text-decoration: none;
  }
}
.forget :hover{
  color: white;
}
.link2{
  position: absolute;
  left: 50px;
  top: 35px;
  font-size: 20px;
  z-index: 999;
  color: white;
}
.el-link.el-link--default{
  color: white;
}
</style>

